import * as actionTypes from '../actions/actionTypes';

export const fetchExpenses = (data) => {
    return {
        type: actionTypes.FETCH_EXPENSES,
        data
    }
}
export const createExpense = (data) => {
    return {
        type: actionTypes.CREATE_EXPENSE,
        data
    }
}
export const deleteExpense = (id) => {
    console.log(id);
    return {
        type: actionTypes.DELETE_EXPENSE,
        id
    }
}
export const updateExpense = (data) => {
    return {
        type: actionTypes.UPDATE_EXPENSE,
        data
    }
}
export const clearExpenses = () => {
    return {
        type: actionTypes.CLEAR_EXPENSES
    }
}